var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fragment"},[_c('RequestFundsIndividualUser',{attrs:{"RF":_vm.RF},on:{"save":_vm.save}}),(_vm.isIbanPopup)?_c('IbanPopup',{attrs:{"accountBank":_vm.RF.data.accountType},on:{"close":function($event){_vm.isIbanPopup = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }